import GeneratedGroupServiceApi from "./generated/GeneratedGroupServiceApi"

class GroupServiceApi extends GeneratedGroupServiceApi {

}

export const groupServiceApi = new GroupServiceApi()
